import { baseSubscription } from '@/utils/subscriptionHandler';
import SearchProjectCellsApi from '@/services/graphql/searchProjectCells';
const subscribeSearchProjectCellsResult = (variables, next) => baseSubscription({
  variables,
  next,
  subscriptionFunction: SearchProjectCellsApi.subscribeSearchProjectCellsResult,
  unsubscribe: false,
},);
export { subscribeSearchProjectCellsResult };
